// src/buttons/defaultToolbarControls.tsx
import React from "react";
import { ExpandButton } from "./ExpandButton.mjs";
import { RemoveButton } from "./RemoveButton.mjs";
import { ReplaceButton } from "./ReplaceButton.mjs";
import { SplitButton } from "./SplitButton.mjs";
var DEFAULT_CONTROLS_WITH_CREATION = React.Children.toArray([
  /* @__PURE__ */ React.createElement(ReplaceButton, null),
  /* @__PURE__ */ React.createElement(SplitButton, null),
  /* @__PURE__ */ React.createElement(ExpandButton, null),
  /* @__PURE__ */ React.createElement(RemoveButton, null)
]);
var DEFAULT_CONTROLS_WITHOUT_CREATION = React.Children.toArray([/* @__PURE__ */ React.createElement(ExpandButton, null), /* @__PURE__ */ React.createElement(RemoveButton, null)]);
export {
  DEFAULT_CONTROLS_WITHOUT_CREATION,
  DEFAULT_CONTROLS_WITH_CREATION
};
